// extracted by mini-css-extract-plugin
export default {"contenedor":"styles_contenedor__0CLG3","buttonContainer":"styles_buttonContainer__g6r0a","texto":"styles_texto__oE3Hk","containerCheck":"styles_containerCheck__7ytOf"};